/** Data de hoje (`AAAA-MM-DD`) no fuso de Brasília, a referência dos vencimentos. */
export const hojeBrasilia = (agora: Date = new Date()): string =>
  agora.toLocaleDateString("en-CA", { timeZone: "America/Sao_Paulo" });
